import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartCreateResponse } from './multiCartMappers'

type CreateRequest = Omit<paths['/api/carts/multi-carts']['post']['parameters']['body']['payload'], 'brand'>
type CreateResponse = paths['/api/carts/multi-carts']['post']['responses']['201']['content']['application/json']

export function createMultiCart(name: string): Promise<App.MultiCartSummary> {
  return request.post<CreateResponse, CreateRequest>('/api/carts/multi-carts', { name }, { credentials: 'include' }).then(mapMultiCartCreateResponse)
}
